import React from 'react' //   } //   //  useEffect //   // useState, //   // useMemo, // , {
import { useHistory, useLocation } from 'react-router-dom'
import { makeStyles, Tab, Box } from '@material-ui/core'
import { ReactComponent as ViewAllIcon } from 'src/mobile/assets/icons/Home_all.svg'
import TabContext from '@material-ui/lab/TabContext'
import TabList from '@material-ui/lab/TabList'
import TabPanel from '@material-ui/lab/TabPanel'
import PaymentTutorial from '../../pages/addOrder/PaymentTutorial'
import { ReactComponent as Suona } from 'src/mobile/assets/icons/suona.svg'
import { useTranslation } from 'react-i18next'
import translationHK from 'src/assets/locales/zh-HK/translation.json'
import { buttonClick, articleClick } from 'src/utils/trackingCode'

const useStyles = makeStyles((theme) => ({
  root: {},
  viewAllbtn: {
    // width: theme.spacing(42.75),
    height: theme.spacing(7),
    background: theme.palette.secondary.main,
    borderRadius: theme.spacing(1),
    padding: '16px 24px',
    textAlign: 'center',
    justifyContent: 'center',
    margin: '0 auto',
    color: 'white',
    fontSize: theme.spacing(2),
    fontWeight: 600,
    marginBottom: theme.spacing(8),
    display: 'flex',
  },
  viewAllbtnIcon: {
    marginTop: theme.spacing(0.4),
    marginLeft: theme.spacing(1),
  },
  PromotionListContainer: {
    // width: 342,
    // margin: '0 auto',
  },
  PromotionContainer: {
    lineHeight: '150%',
    fontWeight: 600,
    fontSize: 14,
    borderRadius: 8,
  },
  PromotionBox: {
    marginTop: theme.spacing(2),
    color: '#F57457',
    display: 'flex',
  },
  PromotionTitle: {
    fontSize: 23,
    marginTop: theme.spacing(1.5),
    lineHeight: '150%',
    marginBottom: theme.spacing(1.5),
    textOverflow: 'ellipsis',
    display: '-webkit-box',
    WebkitLineClamp: 2,
    lineClamp: 2,
  },
  PromotionTime: {
    color: '#9CA3AF',
    // lineHeight: "150%",
    marginBottom: theme.spacing(4),
  },
  imgstyle: {
    borderRadius: 8,
  },
}))

import { useImageTranslation } from 'src/hooks'

const Promotion = () => {
  const history = useHistory()
  const classes = useStyles()
  const { t } = useTranslation()
  const [tImage] = useImageTranslation()
  const location = useLocation()
  const [value, setValue] = React.useState(location?.state?.value || '1')

  const AllPromotion = () => {
    const PromotionList = [
      {
        path: `/promotions_NEW330`,
        promotionSrc: tImage('program_banner', 'webp'),
        text: t('promotion.Healthcheck'),
        time: '21.02.2023',
        content_title: translationHK?.promotion?.Healthcheck, // tracking code需要繁体中文title
      },
      // {
      //   path: `/agreement/${
      //     process.env.NODE_ENV === 'development' || process.env.REACT_APP_ENV === 'development' ? 16 : 8
      //   }`,
      //   promotionSrc: tImage('Banner2_revamp', 'webp'),
      //   text: t('promotion.atome_offers'),
      //   time: '19.02.2023',
      // },
      // {
      //   path: `/agreement/${
      //     process.env.NODE_ENV === 'development' || process.env.REACT_APP_ENV === 'development' ? 16 : 8
      //   }`,
      //   promotionSrc: tImage('Promotion_img', 'webp'),
      //   text: t('promotion.first_offers'),
      //   time: '30.07.2023',
      //   content_title: translationHK?.promotion.first_offers
      // },
      // {
      //   path: `/agreement/${
      //     process.env.NODE_ENV === 'development' || process.env.REACT_APP_ENV === 'development' ? 16 : 8
      //   }`,
      //   promotionSrc: tImage('Promotion_img2', 'webp'),
      //   text: t('promotion.summer_sales'),
      //   time: '22.05.2023',
      //   content_title: translationHK?.promotion.summer_sales
      // },
    ]
    return (
      <Box className={classes.PromotionListContainer}>
        {PromotionList?.map((item, index) => (
          <Box
            key={index}
            className={classes.PromotionContainer}
            onClick={() => {
              articleClick('EH_Promo_Article', 'EH_Promo_Article', item?.content_title, item.path)
              history.push(item.path)
            }}
          >
            <img width="100%" src={item.promotionSrc} alt="Promotion img" className={classes.imgstyle} />
            <Box>
              <Box className={classes.PromotionBox}>
                <Suona />
                <Box mt={0.1} ml={0.5}>
                  {t('glossary. promotion_discount')}
                </Box>
              </Box>
              <Box className={classes.PromotionTitle}>{item.text}</Box>
              <Box className={classes.PromotionTime}>{item.time}</Box>
            </Box>
          </Box>
        ))}
      </Box>
    )
  }
  const handleChange = (event, newValue) => {
    const buttonName = newValue === '1' ? 'EH_Promo_AllPromos_Tab' : 'EH_Promo_CodeUsage_Tab'
    const buttonId = newValue === '1' ? 'EH_Promo_AllPromos_Tab' : 'EH_Promo_CodeUsage_Tab'
    buttonClick(buttonName, buttonId)
    setValue(newValue)
  }

  return (
    <Box>
      <Box sx={{ width: '100%', typography: 'body1' }}>
        <TabContext value={value}>
          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <TabList onChange={handleChange} aria-label="lab API tabs example" variant="fullWidth">
              <Tab label={t('glossary.all_promotion')} value="1" />
              <Tab label={t('glossary.promotion_use_function')} value="2" />
            </TabList>
          </Box>
          <TabPanel
            value="1"
            //  margin="0 auto"
          >
            <AllPromotion />
          </TabPanel>
          <TabPanel value="2">
            <PaymentTutorial />
            <Box>
              <Box
                className={classes.viewAllbtn}
                onClick={() => {
                  buttonClick('EH_Promo_CodeUsage_Book', 'EH_Promo_CodeUsage_Book')
                  history.push('/ProductList')
                }}
              >
                <Box>{t('glossary.promotion.to_order')}</Box>
                <ViewAllIcon className={classes.viewAllbtnIcon} />
              </Box>
            </Box>
          </TabPanel>
        </TabContext>
      </Box>
    </Box>
  )
}

export default Promotion
